import { Link } from "react-router-dom";

function Cta() {
  return (
    <section id="contact" className="cta-section">
      
      <div className="cta-overlay"></div>

      <div className="container">
        <div className="cta-box">

          <span className="section-label">GET STARTED TODAY</span>

          <h2>
            Ready to Make <br />
            <span className="highlight">Data-Driven Moves?</span>
          </h2>

          <p>
            Join businesses that trust Datroniq to power their decisions.
            Let’s talk about your data needs.
          </p>

          <div className="cta-buttons">

            <Link to="/contact" className="btn-primary">
				Contact Now
            </Link>

            <Link to="/services" className="btn-ghost">
              Browse Services
            </Link>

          </div>

        </div>
      </div>

    </section>
  );
}

export default Cta;